import { CKDialogProps, CKModal } from 'clearkit';

export const SampleModal = ({ isVisible, onToggle }: CKDialogProps) => {
  return (
    <CKModal hasClickOutside isVisible={isVisible} onToggle={onToggle}>
      <CKModal.Header hasCloseButton onToggle={onToggle}>
        <CKModal.Heading>Sample Target Market Data</CKModal.Heading>
      </CKModal.Header>
      <CKModal.Body className="p-8">
        This is a sample. You cannot prospect these companies, but if it was a
        real setup, this would search for contacts at all of the selected
        companies.
      </CKModal.Body>
    </CKModal>
  );
};
